import React from 'react';
import { Search, Building2, Ruler } from 'lucide-react';
import IconChip from '../components/IconChip';
import ExploreLink from '../components/ExploreLink';

const ICONS = { search: Search, building: Building2, ruler: Ruler };

// §7.1.3 — editorial service card: ghost index, animated gradient border, icon,
// title, body, Explore link. The whole card is a stretched link (see home.css).
export default function ServiceCard({ service, index = 0 }) {
  const Icon = ICONS[service.icon] || Search;
  return (
    <article className="service-card">
      <span className="service-card__index" aria-hidden="true">
        {String(index + 1).padStart(2, '0')}
      </span>
      <span className="service-card__bar" aria-hidden="true" />
      <IconChip size={64} variant="default" className="service-card__chip">
        <Icon size={28} />
      </IconChip>
      <h3 className="service-card__title">{service.title}</h3>
      <p className="service-card__body">{service.body}</p>
      <ExploreLink
        href={service.ctaHref}
        label={service.ctaLabel}
        className="service-card__cta"
        ariaLabel={`${service.ctaLabel || 'Explore'} — ${service.title}`}
      />
    </article>
  );
}
